module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"page.title":"{name} :: ประวัติ","page.header":"ประวัติการเปลี่ยนแปลงของ Drone ตัวนี้","page.description":"รายการการเปลี่ยนแปลงทั้งหมดของ Drone ตัวนี้","histories.show.tickets":"แสดง Ticket","histories.show.services":"แสดงงานซ่อม","history.all":"ประวัติทั้งหมด","history.selected":"งานที่เกี่ยวข้องกับ {serviceNo}"}}')
  delete Component.options._Ctor
}
